<template>
    <div class="flex space-x-1">
        <div
            v-for="number in max"
            :class="number <= value ? 'bg-indigo-400' : 'bg-gray-200'"
            class="shrink-0 w-2.5 h-2.5 rounded-full"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'SmallNumberRangeIndicator',
    props: {
        max: {
            required: true,
            type: Number,
        },
        value: {
            required: true,
        },
    },
};
</script>
